import {memo} from 'react'

import {useAsyncQueueProcessor} from '../hooks/useAsync'

export const AsyncQueueProcessor = memo(function AsyncQueueProcessor() {
  useAsyncQueueProcessor()

  return null
})
